import * as dtos from "@/models/dtos";
import { useStore } from "vuex";
import { MainContainer } from "./MainContainer";
import {
  getCompanyLogoUrl,
  getImageUrl,
  imageDoesExist,
} from "@/utils/getImages";
import { last } from "lodash";

export class Profile {
  Container: MainContainer;
  Name: dtos.DynamicProperty;
  DisplayName: dtos.DynamicProperty;
  OrganisationNumber: dtos.DynamicProperty;
  CompanyDescription: dtos.DynamicProperty;
  Address: dtos.DynamicProperty;
  ZipCode: dtos.DynamicProperty;
  City: dtos.DynamicProperty;
  PhoneNumber: dtos.DynamicProperty;
  Fax: dtos.DynamicProperty;
  Email: dtos.DynamicProperty;
  Website: dtos.DynamicProperty;
  DNS: dtos.DynamicProperty;
  PublicBanner: dtos.DynamicProperty;
  TopBanner: string;
  Facebook: dtos.DynamicProperty;
  Twitter: dtos.DynamicProperty;
  Instagram: dtos.DynamicProperty;
  LinkedIn: dtos.DynamicProperty;
  Github: dtos.DynamicProperty;
  YouTube: dtos.DynamicProperty;
  Podcast: dtos.DynamicProperty;
  Agreement: dtos.DynamicProperty;
  GdprContact: dtos.DynamicProperty;
  GdprAddress: dtos.DynamicProperty;
  Members: dtos.DynamicProperty;
  CompanyLogo: dtos.DynamicProperty;
  Logo: string;
  ShowGender: dtos.DynamicProperty;
  ShowAge: dtos.DynamicProperty;

  LinkToCompanyHistoryPage: dtos.DynamicProperty;
  LinkToCompanyTeamPage: dtos.DynamicProperty;
  LinkToCompanyCareerPage: dtos.DynamicProperty;
  LinkToCompanyOurCustomersPage: dtos.DynamicProperty;
  LinkToCompanyFAQPage: dtos.DynamicProperty;
  LinkToCompanySupportPage: dtos.DynamicProperty;
  constructor(container: MainContainer) {
    this.Container = container;
    this.build();
  }

  private build() {
    this.OrganisationNumber = this.getOrCreate(
      "Orgainsationsnummer",
      "/profile/organisationNumber",
      "text"
    );
    this.ShowAge = this.getOrCreate(
      "Visa kandidatens ålder",
      "/profile/showAge",
      "checkbox"
    );
    if (typeof undefined == typeof this.ShowAge.data) this.ShowAge.data = true;
    this.ShowGender = this.getOrCreate(
      "Visa vilket juridiskt kön kandidaten tillhör",
      "/profile/showGender",
      "checkbox"
    );
    if (typeof undefined == typeof this.ShowGender.data)
      this.ShowGender.data = true;

    this.OrganisationNumber = this.getOrCreate(
      "Orgainsationsnummer",
      "/profile/organisationNumber",
      "text"
    );
    this.DisplayName = this.getOrCreate(
      "Visningsnamn",
      "/profile/organisationDescription",
      "text",
      "T.ex. Ansökningsportalen"
    );
    this.CompanyDescription = this.getOrCreate(
      "Företagsbeskrivning",
      "/profile/companyDescription",
      "textarea",
      "Den här texten visas på era annonser."
    );
    this.Address = this.getOrCreate("Adress", "/profile/address", "text");

    this.ZipCode = this.getOrCreate("Postnummer", "/profile/zipCode", "text");
    this.City = this.getOrCreate("Postort", "/profile/city", "text");
    this.PhoneNumber = this.getOrCreate(
      "Telefonnummer",
      "/profile/phoneNumber",
      "text"
    );
    this.Fax = this.getOrCreate("Fax", "/profile/fax", "text");
    this.Email = this.getOrCreate("E-post", "/profile/email", "text");
    this.Website = this.getOrCreate("Hemsida", "/profile/website", "text");
    this.DNS = this.getOrCreate("DNS", "/profile/dns", "text");
    this.PublicBanner = this.getOrCreate(
      "Publik banner",
      "/profile/images/publicbanner",
      "imageBase64"
    );
    this.Agreement = this.getOrCreate(
      "Villkor",
      "/profile/agreement",
      "textarea"
    );
    this.Facebook = this.getOrCreate(
      "Facebook",
      "/profile/socialMedia/facebook",
      "text"
    );
    this.Twitter = this.getOrCreate(
      "X",
      "/profile/socialMedia/twitter",
      "text"
    );
    this.Instagram = this.getOrCreate(
      "Instagram",
      "/profile/socialMedia/instragram",
      "text"
    );
    this.LinkedIn = this.getOrCreate(
      "LinkedIn",
      "/profile/socialMedia/linkedin",
      "text"
    );
    this.Github = this.getOrCreate(
      "Github",
      "/profile/socialMedia/github",
      "text"
    );
    this.YouTube = this.getOrCreate(
      "YouTube",
      "/profile/socialMedia/youtube",
      "text"
    );
    this.Podcast = this.getOrCreate(
      "Podcast",
      "/profile/socialMedia/podcast",
      "text"
    );
    this.GdprContact = this.getOrCreate(
      "Kontaktuppgift för GDPR-ärenden",
      "/profile/gdpr/contact",
      "text",
      "T.ex. namn och telefonnummer eller e-postadress."
    );
    this.GdprAddress = this.getOrCreate(
      "Adress för GDPR-ärenden",
      "/profile/gdpr/address",
      "textarea"
    );
    this.Members = this.getOrCreate(
      "Lista alla medlemmar som kandidaten måste godkänna",
      "/profile/members",
      "textarea"
    );
    this.CompanyLogo = this.getOrCreate(
      "Företagslogo",
      "/profile/images/companylogo",
      "imageBase64"
    );
    this.LinkToCompanyHistoryPage = this.getOrCreate(
      "Företagets historia",
      "/profile/aboutUs/history",
      "text"
    );
    this.LinkToCompanyTeamPage = this.getOrCreate(
      "Möt teamet",
      "/profile/aboutUs/team",
      "text"
    );
    this.LinkToCompanyCareerPage = this.getOrCreate(
      "Karriär",
      "/profile/aboutUs/career",
      "text"
    );
    this.LinkToCompanyOurCustomersPage = this.getOrCreate(
      "Våra kunder",
      "/profile/aboutUs/customers",
      "text"
    );
    this.LinkToCompanyFAQPage = this.getOrCreate(
      "FAQ",
      "/profile/links/faq",
      "text"
    );
    this.LinkToCompanySupportPage = this.getOrCreate(
      "Support",
      "/profile/links/support",
      "text"
    );
    this.TopBanner = getImageUrl(
      this.Container.DTO.id,
      `${this.Container.DTO.id}/profile/images/publicbanner`
    );
    this.Logo = getImageUrl(
      this.Container.DTO.id,
      `${this.Container.DTO.id}/profile/images/companylogo`
    );
  }
  private getOrCreate(
    name: string,
    key: string,
    type: string,
    placeholder?: string
  ) {
    let property = this.Container?.DTO?.metadata?.properties?.find((px) => {
      return px.key === key;
    });
    if (typeof undefined === typeof property) {
      property = new dtos.DynamicProperty();
      property.key = key;
      property.placeholder = placeholder || name;
      property.label = name;
      property.type = type;
      this.Container?.DTO?.metadata?.properties?.push(property);
    } else {
      property.placeholder = placeholder || name;
      property.label = name;
    }
    return property;
  }

  private remove(name: string, key: string, type: string) {
    const property = this.Container?.DTO?.metadata?.properties?.find((px) => {
      return px.key === key;
    });
    if (typeof undefined !== typeof property) {
      this.Container?.DTO?.metadata?.properties?.splice(
        this.Container?.DTO?.metadata?.properties?.indexOf(property),
        1
      );
    }
    return property;
  }
}
